import axios from "../../../axios"
import { paramsObjToGraphQLParams } from "@/utils/index.js"

export default {
  fetch(queryData) {
    return axios.post('', {
      query: `
        query {
          categories ${paramsObjToGraphQLParams(queryData)} {
            order_by,
            pagination_page,
            pagination_limit,
            total_pages,
            items {
              id,
              name,
              slug,
              activated,
              created_at,
              updated_at,
              image_url,
              description
            }
          }
        }
      `
    })
  },
  add(category) {
    return axios.post('', {
      query: `
        mutation {
          createCategory (
            name: "${category.name}",
            image_url: "${category.image_url}",
            description: "${category.description}"
          ) {
            id,
            name,
            slug,
            activated,
            created_at,
            updated_at,
            image_url,
            description
          }
        }
      `
    })
  },
  update(category) {
    return axios.post('', {
      query: `
        mutation {
          updateCategory (
            id: ${category.id},
            name: "${category.name}",
            image_url: ${category.image_url ? `"${category.image_url}"` : null},
            description: ${category.description ? `"${category.description}"` : null},
            activated: ${category.activated}
          ) {
            id,
            name,
            slug,
            activated,
            created_at,
            updated_at,
            image_url,
            description
          }
        }
      `
    })
  },
  delete(categoryId) {
    return axios.post('', {
      query: `
        mutation {
          deleteCategory (
            id: ${categoryId}
          )
        }
      `
    })
  },
  infos(categoryId) {
    return axios.post('', {
      query: `
        query {
          categoryInfos (
            id: ${categoryId}
          ) {
            id,
            name,
            slug,
            activated,
            created_at,
            updated_at,
            image_url,
            description
          }
        }
      `
    })
  }
}
